export default "__VITE_ASSET__S4lh4me3__"